import * as queries from './queries';
import * as mutations from './mutations';
import * as subscriptions from './subscriptions';

const io = {
  queries,
  mutations,
  subscriptions
};
export default io;
